/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { ICON_CHECK } from '../../../../Icons';
import { SdsIcon } from '../../../SdsIcon';
import { SdsText, SdsTextWeight } from '../../../SdsText';
import { SourceItemProps } from './SourceItem.props';

/**
 * SDS source item component.
 */
export const SourceItem = (props: SourceItemProps): JSX.Element => {
  const { accessibleProps, isSelected, onSelect, source } = props;

  return (
    <li className="sds-source-selector__item">
      <button {...accessibleProps} onClick={() => onSelect(source)}>
        <div className="sds-source-selector__icon">
          <SdsIcon svg={source.icon} />
        </div>
        <SdsText fontWeight={SdsTextWeight.Semibold} text={source.name} />
        {isSelected && <SdsIcon classes="sds-source-selector__check" svg={ICON_CHECK} />}
      </button>
    </li>
  );
};
